import { useEffect } from 'react';

import { medirProducto } from '@/lib/medir';

/** Cuenta que alguien miró la ficha de un producto. */
export function MedirProducto({ code, brand }: { code: string; brand: string | null }) {
  useEffect(() => {
    medirProducto(code, brand);
  }, [code, brand]);

  return null;
}
